interface ResolveNavItemStyleParams {
  hasWarnings: boolean;
  isActive: boolean;
  isDisabled: boolean;
  isClickable: boolean;
}

interface ResolveNavItemColorClassParams extends ResolveNavItemStyleParams {
  variant: 'icon' | 'title';
}

const DISABLED_COLOR_CLASS = 'text-[#BDBDBD]';
const WARNING_COLOR_CLASS = 'text-[#BB4D00]';
const ACTIVE_COLOR_CLASS = 'text-[#008236]';
const DEFAULT_ICON_COLOR_CLASS = 'text-gray-700';
const DEFAULT_TITLE_COLOR_CLASS = 'text-gray-900';

export function resolveNavItemColorClass({
  hasWarnings,
  isActive,
  isDisabled,
  variant,
}: ResolveNavItemColorClassParams): string {
  if (hasWarnings) {
    return WARNING_COLOR_CLASS;
  }

  if (isActive) {
    return ACTIVE_COLOR_CLASS;
  }

  if (isDisabled) {
    return DISABLED_COLOR_CLASS;
  }

  if (variant === 'icon') {
    return DEFAULT_ICON_COLOR_CLASS;
  }

  return DEFAULT_TITLE_COLOR_CLASS;
}

export function resolveNavItemContainerClass({
  hasWarnings,
  isActive,
  isDisabled,
  isClickable,
}: ResolveNavItemStyleParams): string {
  const classes = ['flex w-full min-h-14 items-center gap-3 rounded-lg px-3 py-2 text-left transition-colors'];

  if (hasWarnings) {
    classes.push('bg-[#FFFBEB]');
  } else if (isActive) {
    classes.push('bg-[#DCFCE7]');
  } else {
    classes.push('bg-transparent');
  }

  if (isDisabled) {
    classes.push('cursor-not-allowed');
  } else if (isClickable) {
    classes.push('cursor-pointer');

    if (hasWarnings) {
      classes.push('hover:bg-[#FEF3C7]');
    } else {
      classes.push('hover:bg-gray-50');
    }
  }

  return classes.join(' ');
}
